import OneEvent from "../event/OneEvent";
import NativeMethods from "./NativeMethods";
import MultipleEvent from "../event/MultipleEvent";
import { isChina, isMalaysia } from "../country";
const globalEvent: any = new MultipleEvent();

/**
 * 在安卓app中
 */
export function inAndroidApp() {
  return (
    (isChina() && !!window.wintogether) || (isMalaysia() && !!window.speedworkb)
  );
}

/**
 * 在ios app中
 */
export function inIOSApp() {
  return !!(
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.WT_H5_IOS
  );
}

/**
 * 在移动app中
 */
export function inMobileApp() {
  return inAndroidApp() || inIOSApp();
}

/**
 * 移动app提供的实例
 */
export function mobileAppInstance() {
  // 安卓提供的全局变量
  if (inAndroidApp()) {
    return window.wintogether || window.speedworkb;
  }
  // ios
  if (inIOSApp()) {
    return window.webkit.messageHandlers;
  }

  return undefined;
}

/**
 * 默认空函数
 * @param methodName
 */
const emptyFn = function (methodName: string) {
  console.log(`not exist ${methodName} method`);
};

/**
 * 安卓交互
 * @param methodName
 * @param data
 */
export function sendAndroid(methodName: string, ...data: any[]) {
  if (
    ["toWinOrderCorfirm", "callTyreOrderDetailWithHead"].includes(methodName)
  ) {
    data = [data[0], true];
  } else if (["callFullScreenTyreOrderDetail"].includes(methodName)) {
    data = [data[0], false];
  }

  // 兼容ios，安卓处理
  if (
    [
      "toWinOrderCorfirm",
      "callTyreOrderDetailWithHead",
      "callFullScreenTyreOrderDetail"
    ].includes(methodName)
  ) {
    methodName = "callWeb";
  }

  const method = mobileAppInstance()[methodName];
  if (method) {
    console.log(methodName, data);
    // 安卓提供的实例不可改变，方法不能使用call，apply调用
    return mobileAppInstance()[methodName](...data);
  } else {
    console.log("Android App don't include this method —— " + methodName);
    return emptyFn(methodName);
  }
}

/**
 * 向ios传送数据
 * @param {String} methodName
 * @param {Object} message
 */
export function sendIOS(methodName: string, ...message: any) {
  if (methodName === "callWeb") {
    message = [
      {
        url: message[0],
        hasTitle: message[1],
        hasStatusBar: message[2]
      }
    ];
  }

  const method = mobileAppInstance()[methodName];
  if (method) {
    method.postMessage({
      body: methodName,
      message: message[0] // ios暂时只能接收一个参数
    });
  } else {
    console.log("IOS App don't include this method —— " + methodName);
    return emptyFn(methodName);
  }
}

/**
 * 发送IOS参数，并且获取返回值。
 * 需要注意的是，不能连续重复调用一个方法，如果连续调用，$on，$emit会出现覆盖问题。
 * 这时候可以考虑，做本地缓存。防止连续调用。参考函数——getAppStatusBarHeight
 * 异步请求
 * @param {String} methodName
 * @param {Object} message
 */
export function asyncSendIOS(methodName: string, message: any) {
  // 异步函数需要先定义回调函数
  window.IOSCallback = IOSCallback;
  return new Promise((resolve, reject) => {
    let tempTimer: any;
    globalEvent.$on(methodName, (data: any) => {
      tempTimer && clearTimeout(tempTimer);
      resolve(data);
    });
    // 发送
    sendIOS(methodName, message);
    // 设置20秒超时
    tempTimer = setTimeout(() => {
      tempTimer && clearTimeout(tempTimer);
      reject(methodName + "-- timeout");
    }, 20 * 1000);
  }).catch(err => console.log(err));
}
/**
 * IOS回调函数
 * @param {Object} data
 */
export function IOSCallback(data: any = {}) {
  const { name, value } = data;

  // app主动通知，保存token
  // if (name === "iosToken") {
  //   value && localStorage.setItem("token", value);
  //   location.reload();
  // }
  globalEvent.$emit(name, value);
}

/**
 * 获取发送方法-不需要返回值
 */
export function getSendMethod() {
  if (inAndroidApp()) {
    return sendAndroid;
  } else if (inIOSApp()) {
    return sendIOS;
  }
}

/**
 * 获取发送方法-需要返回值
 */
export function getAsyncSendMethod() {
  if (inAndroidApp()) {
    return sendAndroid;
  } else if (inIOSApp()) {
    return asyncSendIOS;
  }
}

/**
 * 给对象增加字段属性
 * @param instance 注册的实例对象
 * @param fields 字段数据
 * @param getDescriptor 配置项
 */
const defineProperties = (
  instance: any,
  fields: string[],
  getDescriptor: Function
) => {
  return Object.defineProperties(
    instance,
    Object.assign({}, ...fields.map(name => getDescriptor(name)))
  );
};

/**
 * 单例，创建app交互对象
 */
export default class MobileApp {
  nativeInstance = null;

  constructor() {
    if (this.nativeInstance) return this.nativeInstance;
    return this.registerNativeApp();
  }

  // 注册交互方法
  registerNativeApp() {
    this.nativeInstance = Object.create(null);

    for (let key in NativeMethods) {
      const method = key === "async" ? getAsyncSendMethod() : getSendMethod();

      defineProperties(this.nativeInstance, NativeMethods[key], function (
        methodName: string
      ) {
        return {
          [methodName]: {
            get() {
              if (inMobileApp()) {
                return method.bind(this, methodName);
              } else {
                return function () {
                  console.log(`不在APP: ${methodName}`);
                };
              }
            }
          }
        };
      });
    }

    return this.nativeInstance;
  }
}
